<template>
  <div class="privacy-policy">
    <div class="container">
      <h1>מדיניות פרטיות</h1>
      <div class="policy-content">
        <section>
          <h2>מבוא</h2>
          <p>
            אנו ב-"העלאת סרטוני יוטיוב ל-Google Drive" (להלן: "השירות") מכבדים את פרטיותך ומחויבים להגן על המידע האישי שלך. מסמך זה מסביר כיצד אנו אוספים, משתמשים ומגינים על המידע שאתה מספק לנו.
          </p>
        </section>

        <section>
          <h2>המידע שאנו אוספים</h2>
          <p>אנו אוספים את המידע הבא:</p>
          <ul>
            <li><strong>פרטי חשבון Google:</strong> השירות מבקש גישה לחשבון Google Drive שלך באמצעות OAuth 2.0.</li>
            <li><strong>נתוני סרטונים:</strong> קישורים לסרטוני YouTube שאתה בוחר להעלות לחשבון הדרייב שלך.</li>
            <li><strong>עוגיות YouTube:</strong> לפני כל הורדה, תוסף הדפדפן קורא עוגיות המשויכות ל־youtube.com ומעביר אותן ישירות לשירות ההורדות בקובץ Netscape. בזרימה האוטומטית קוד האתר מקבל רק חיווי הצלחה ואינו מקבל את ערכי העוגיות. אם בחרת קובץ ידני, הדפדפן קורא ומעלה את הקובץ שבחרת.</li>
          </ul>
        </section>

        <section>
          <h2>כיצד אנו משתמשים במידע</h2>
          <p>המידע שאנו אוספים משמש אך ורק למטרות הבאות:</p>
          <ul>
            <li>הורדת סרטונים מיוטיוב והעלאתם לחשבון הדרייב שלך, לפי בקשתך.</li>
            <li>אימות הזהות שלך והרשאות הגישה לדרייב שלך.</li>
            <li>שימוש בעוגיות YouTube לצורך ביצוע בקשת ההורדה שיזמת, לרבות תוכן ש־YouTube דורש עבורו אימות.</li>
          </ul>
        </section>

        <section>
          <h2>הרשאות Google</h2>
          <p>השירות מבקש את ההרשאה הבאה:</p>
          <ul>
            <li><strong>https://www.googleapis.com/auth/drive.file</strong> - הרשאה זו מאפשרת לשירות לראות, ליצור ולערוך רק את הקבצים שהשירות יצר בחשבון הדרייב שלך.</li>
          </ul>
          <p>שים לב: איננו מקבלים גישה מלאה לכל הקבצים בדרייב שלך, אלא רק לקבצים שהשירות יוצר.</p>
        </section>

        <section>
          <h2>שמירת מידע</h2>
          <p>
            אנו שומרים את הטוקן שמספק Google רק בדפדפן שלך (localStorage) כדי לאפשר גישה לדרייב שלך במהלך השימוש בשירות. בעת הורדה, קובץ עוגיות YouTube מועבר ישירות מהתוסף לשירות ההורדות תחת מזהה הלקוח של האתר, ומשמש לביצוע ההורדה. עותק עדכני נשלח מחדש לפני כל בקשת הורדה.
          </p>
        </section>

        <section>
          <h2>שיתוף מידע עם צדדים שלישיים</h2>
          <p>
            איננו משתפים את המידע האישי שלך עם צדדים שלישיים, למעט במקרים הבאים:
          </p>
          <ul>
            <li>כאשר הדבר נדרש לפי חוק.</li>
            <li>כדי להגן על הזכויות או הביטחון של השירות, המשתמשים שלנו או הציבור.</li>
          </ul>
        </section>

        <section>
          <h2>האבטחה שלך</h2>
          <p>
            אנו מיישמים אמצעי אבטחה סבירים כדי להגן על המידע האישי שלך מפני גישה, שימוש או חשיפה לא מורשים. עם זאת, אין שיטת העברה באינטרנט או אחסון אלקטרוני שהיא בטוחה ב-100%.
          </p>
        </section>

        <section>
          <h2>הזכויות שלך</h2>
          <p>אתה רשאי:</p>
          <ul>
            <li>לבטל את ההרשאות שנתת לשירות דרך <a href="https://myaccount.google.com/permissions" target="_blank">מרכז ההרשאות של Google</a>.</li>
            <li>להשבית או להסיר את תוסף הדפדפן, או לבטל את הרשאת הגישה שלו ל־youtube.com דרך הגדרות התוספים בדפדפן.</li>
            <li>למחוק את הקבצים שהשירות העלה לדרייב שלך.</li>
          </ul>
        </section>

        <section>
          <h2>שינויים במדיניות הפרטיות</h2>
          <p>
            אנו עשויים לעדכן את מדיניות הפרטיות שלנו מעת לעת. נודיע לך על שינויים מהותיים במדיניות זו על ידי פרסום הגרסה המעודכנת באתר שלנו.
          </p>
        </section>

        <section>
          <h2>יצירת קשר</h2>
          <p>
            אם יש לך שאלות או חששות לגבי מדיניות הפרטיות שלנו, אנא צור קשר בכתובת המייל: [8596960@gmail.com].
          </p>
        </section>

        <div class="last-updated">
          עודכן לאחרונה: 26 באוגוסט, 2026
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 40px auto;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

h1 {
  color: var(--primary-color);
  text-align: center;
  margin-bottom: 30px;
}

h2 {
  color: var(--secondary-color);
  margin-top: 25px;
  margin-bottom: 15px;
  font-size: 1.5rem;
}

.policy-content {
  line-height: 1.6;
  text-align: right;
}

section {
  margin-bottom: 25px;
}

ul {
  margin: 10px 0;
  padding-right: 20px;
}

li {
  margin-bottom: 8px;
}

.last-updated {
  margin-top: 40px;
  font-style: italic;
  color: #666;
  text-align: center;
}

a {
  color: var(--primary-color);
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>
